var map = {
	"./Cuarto01KARLA_gal_g.webp": "./src/img/brands/emptyrooms/Cuarto01KARLA_gal_g.webp",
	"./DWQDLQYCI5EURKP7O6J2FEINH4.jpg.avif": "./src/img/brands/emptyrooms/DWQDLQYCI5EURKP7O6J2FEINH4.jpg.avif",
	"./Gnota_61778.webp": "./src/img/brands/emptyrooms/Gnota_61778.webp",
	"./MPNGXQIFOZH4XGWIPYYDN5R2PI.jpg.avif": "./src/img/brands/emptyrooms/MPNGXQIFOZH4XGWIPYYDN5R2PI.jpg.avif",
	"./Z7BKVD5ZUVA2DLJMOBNISJ7CPI.jpg.avif": "./src/img/brands/emptyrooms/Z7BKVD5ZUVA2DLJMOBNISJ7CPI.jpg.avif",
	"./empty-rooms-mexico-missing-women-2022.jpg.webp": "./src/img/brands/emptyrooms/empty-rooms-mexico-missing-women-2022.jpg.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img/brands/emptyrooms sync \\.(webp%7Cjpg%7Cjpeg%7Cavif)$";